import '@/js/desktop/plugins/select2';
/* eslint-disable */
import ymapsLoader from "ymaps";
import appConfig from "@fr/config/appConfig";
import ResortEntity from "@/js/common/Domain/Entity/Resort";
import icon_point_current from '@/img/map/icon_point_current.png'
import icon_point from '@/img/map/icon_point.png'
import icon_point_select from '@/img/map/icon_point_select.png'
import { definePanel, requirePanel, getLeftHalfCenterPosition } from '@/js/desktop/components/hotelsMap/use/useYMapsPanel';

var format = function(item) {
	var resortName = item.get('resort') ? (item.get('resort') instanceof ResortEntity ? item.get('resort').get('name') : item.get('resort').name) : false;
	if(item) {
		if(item.text) {
			return item.text;
		} else {
			return item.get('name') + ', ' + item.get('category').get('name') + (resortName ? (',  ' + resortName) : '');
		}
	} else {
		return '';
	}
};

var MapHotelSearch = Backbone.View.extend({
    searchPageModel: null,
	hotelsMapView: null,

	formatSelection: format,
	formatResult: format,
	setSelectData: function(params) {
		var self = this,
			collection = params.collection,
			data = {
				data:{
					results:[],
					text: function(item) {
						return item.get('name');
					}
				},
				placeholder: "Поиск по названию отеля",
				allowClear:true,
				formatSelection: this.formatSelection,
				formatResult: this.formatResult,
				containerCssClass:'fullMob',
				dropdownCssClass:'fullMob hotelSearch',
				dropdownParent: $('.mapLayer'),
				ajax: {
					quietMillis:100,
					data: function (params) {
						return {
							term:params
						};
					},
					results: function (data, page, query) {
						return data;
					},
					transport: function (params) {
						var term = params.data.term ? params.data.term.toLowerCase() : '',
							hotels = _.filter(collection.models, function(hotel){
								return hotel.get('name').toLowerCase().indexOf(term) > -1;
							});

						hotels = _.sortBy(hotels, function(hotel) {
							return hotel.get('name').toLowerCase().indexOf(term) !== 0;
						});

						params.success({
							results: hotels
						});
					}
				}
			},
			popularHotels,
			otherHotels;

		if(collection) {
			data.data.results = collection.models;
		}

		if(params.selection) {
			$.extend(data, {
				initSelection: function(element, callback) {
					callback(params.selection);
				}
			});
		}

		return this.$el.select2(data);
	},
	clearSelection: function() {
		this.$el.select2('data', null);
	},
	collectionChanged: function(event, collection, context) {
		this.setSelectData({
			collection: collection
		});
	},
	initEvents: function() {
		this.searchPageModel.on('change:filteredHotels', $.proxy(this.collectionChanged, this));
	},
	initialize: function(options) {
		var self = this;
		options.searchPageModel ? this.searchPageModel = options.searchPageModel : null;
		options.hotelsMapView ? this.hotelsMapView = options.hotelsMapView : null;

		this.initEvents();

		this.setSelectData({
			collection:this.searchPageModel.get('filteredHotels'),
			selection:null
		})
		.on('change', function(e) {
			var markers = self.hotelsMapView.model.get('markers'),
				selectedHotel = self.$el.select2("data"),
				selectedMarker = _.find(markers, function(marker){
					return marker.hotel.hotel == selectedHotel;
				});

			if(selectedMarker) {
				self.hotelsMapView.showMarkerHotel(selectedMarker);
			}
		});
	}
});

let HotelsMapView = Backbone.Epoxy.View.extend({
    hotelMapView: null,
	hotelSearchField:null,
	searchPageModel:null,
	$hotelInfoContainer:null,
	HotelsList:null,
	hotelMapPanel:null,
	model:new (Backbone.Epoxy.Model.extend({
		defaults: {
			currentHotel: null,
            hotelMarker: null,
			map:null,
			markers:[],
			clusterer:null,
			haveChanges:true
		}
	}))(),
	clearMarkers:function() {
		var clusterer = this.model.get('clusterer'),
			map = this.model.get('map');

		if(clusterer) {
			map.geoObjects.remove(clusterer);
			this.model.set('markers', []);
			this.model.set('clusterer', null);
		}
	},
	findClosestMarkers: function(centralMarker, markers) {
		var lat = centralMarker.position ? centralMarker.position.lat() : null,
			lng = centralMarker.position ? centralMarker.position.lng() : null,
			rad = function (x) {return x*Math.PI/180},
			R = 6371; // radius of earth in km

		if(lat && lng) {
			_.each(markers, function(marker) {
				var mlat = marker.position.lat();
				var mlng = marker.position.lng();
				var dLat  = rad(mlat - lat);
				var dLong = rad(mlng - lng);
				var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
					Math.cos(rad(lat)) * Math.cos(rad(lat)) * Math.sin(dLong/2) * Math.sin(dLong/2);
				var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
				var d = R * c;

				marker.distance = d;
			});
			markers = _.sortBy(markers, 'distance');
		}

		return markers;
	},
	resetMarkerIcons: function() {
		var markers = this.model.get('markers');
		_.each(markers, function(marker) {
			var hotelType = marker.hotel.hotel.hotelType,
				currentHotel = hotelType && hotelType == "current",
				iconToSet = currentHotel ? icon_point_current : icon_point;

			if(marker.options.get('iconImageHref') !== iconToSet) {
				marker.options.set('iconImageHref', iconToSet);
				marker.options.set('iconImageSize', currentHotel ? [32, 46] : [20, 29]);
				marker.options.set('iconImageOffset',  currentHotel ? [-16, -54] : [-10, -29]);
			}
		});
	},
	showMarkerHotel: function(marker, map) {
		var hotel = marker.hotel.hotel,
			bounds,
			markerCoordinates,
			leftHalfCenterPosition,
			self = this,
			map = map ? map : this.model.get('map');

		const icon = (this?.currentHotel?.get('id') === hotel?.get('id')) ? icon_point_current : icon_point_select;

		this.resetMarkerIcons();

		marker.options.set('iconImageHref', icon);
		marker.options.set('iconImageSize', [36, 54]);
		marker.options.set('iconImageOffset', [-18, -54]);

		var hotelView = new this.HotelsList({
			model: hotel,
			hotelMapView: this.hotelMapView,
			collectionView: {
				model: self.searchPageModel,
				collection: _.chain([]),
				filters: {
					model: self.searchPageModel.get('filterCriteria'),
				},
			},
		});
		this.hotelMapPanel?.setContent(hotelView.$el);
		this.hotelMapView.changeHotelOnMapVisible(true);
		bounds = map.getBounds();
		markerCoordinates = marker.geometry.getCoordinates();
		const mapWindow = $('ymaps');
		if (bounds) {
				leftHalfCenterPosition = getLeftHalfCenterPosition(mapWindow, bounds, markerCoordinates);
				map.panTo(leftHalfCenterPosition);
			}
		$('.js-close-card').on('click', () => {
			this.resetMarkerIcons();
			this.hotelSearchField.clearSelection();
		});
	},
	tryOpenFirstHotelInfoFlag:false,
	tryOpenFirstHotelInfo:function() {
		this.tryOpenFirstHotelInfoFlag = true;
	},
    openFirstHotelInfo: function () {
        const markers = this.model.get('markers');
        const hotelMarker = this.model.get('hotelMarker');

        if (markers.length || hotelMarker) {
            this.tryOpenFirstHotelInfoFlag = false;
            this.openHotelInfo(this, hotelMarker || markers[0]);
        }
    },
	openHotelInfo:function(self, marker) {
		self.showMarkerHotel.apply(self, [marker, self.model.get('map')]);
	},
	renderPoints: function() {
		var filteredHotels = this.searchPageModel.get('filteredHotels'),
			needToRenewMap = this.model.get('haveChanges'),
			map = this.model.get('map'),
			self = this,
			markers = [],
			clusterer,
			hotelCoordinates = [];

		if(needToRenewMap) {
			console.log('renderMapPoints');
            this.hotelMapView.changeHotelOnMapVisible();
			this.model.set('haveChanges', false);
			this.clearMarkers();

			if(filteredHotels && filteredHotels.length) {
				this.ymaps.then((ymaps) => {
					ymaps.ready(async () => {
						let hotelMarker = null;

						filteredHotels.each((hotel) => {
							var coordinates = hotel.get('map');

							if (!_.isEmpty(coordinates) && coordinates.lat && coordinates.lon) {
								hotelCoordinates.push({
									hotel: hotel,
									position: [parseFloat(coordinates.lat), parseFloat(coordinates.lon)]
								});
							}
						});

						clusterer = new ymaps.Clusterer({
							preset: 'islands#invertedDarkOrangeClusterIcons',
							groupByCoordinates: false,
							zoomMargin: 30,
						});
						if (this.hotelMapPanel === null) {
							await definePanel(ymaps);
							await requirePanel.call(this, ymaps, map);
						}
						_.each(hotelCoordinates, (hotel) => {
							var position = hotel.position,
								minPrice = hotel.hotel.get('minPrice'),
								HintLayout = ymaps.templateLayoutFactory.createClass(minPrice ? '<div class="infobox__container"><div class="infobox">от $[properties.hintContent]<span class="rubl"> ₽</span></div></div>' : ''),
								currentHotel = hotel.hotel.hotelType && hotel.hotel.hotelType == "current",
								hotelMinPrice = hotel.hotel.get('minPrice'),
								marker = new ymaps.Placemark(position, {
									hintContent: hotelMinPrice ? hotelMinPrice.formatNumber() : '',
									hasHint: !!hotelMinPrice,
								}, {
									iconLayout: 'default#imageWithContent',
									// Своё изображение иконки метки.
									iconImageHref: currentHotel ? icon_point_current : icon_point,
									// Размеры метки.
									iconImageSize: currentHotel ? [36, 54] : [20, 29],
									iconImageOffset: currentHotel ? [-18, -54] : [-10, -29],
									hintCloseTimeout: 0,
									hintOpenTimeout: 0,
									hintOffset: [0, 100],
									hintHoldByMouse: false,
									// Макет содержимого.
									hintLayout: HintLayout
								});

							marker.hotel = hotel;
							marker.events.add('click', () => {
								self.openHotelInfo(self, marker);
							});

							if (self?.currentHotel?.get('id') === hotel?.hotel?.get('id')) {
								this.model.set('hotelMarker', marker);
								hotelMarker = marker;

								return;
							}

							markers.push(marker);
						});

						this.model.set('markers', markers);
						this.model.set('clusterer', clusterer);

						clusterer.add(markers);
						map.geoObjects.add(clusterer);

						if (hotelMarker) {
							this.model.set('hotelMarker', hotelMarker);
							map.geoObjects.add(hotelMarker);
						}

						if (hotelCoordinates.length === 0) return;

						if (this.tryOpenFirstHotelInfoFlag || (hotelMarker && hotelCoordinates.length === 1)) {
							this.openFirstHotelInfo();
						} else {
							map.setBounds(clusterer.getBounds(), {
								checkZoomRange: true,
							});
						}

					});
                });
            }
        }
    },
	initEvents: function() {
		var self = this;

		this.searchPageModel.on('change:filteredHotels', function() {
			var viewMode = self.searchPageModel.get('viewMode');
			self.model.set('haveChanges',true);

			if(viewMode == "map") {
				self.renderPoints();
			}
		});

		this.searchPageModel.on('change:viewMode', function(model, viewMode) {
			if(viewMode == "map") {
				self.renderPoints();
			}
		});

		console.log('initEvents');
	},
	initMap:function(readyCallback){
		var self = this,
			map = this.model.get('map'),
			myOptions = {
				zoom: 10,
				center:[55.751537,37.619273],
				controls: ['typeSelector', 'fullscreenControl', 'zoomControl']
			};
		if(map) {
			if(map == 'loading') {
				this.ymaps.then((ymaps) => {
					readyCallback.call(this);
				});
			} else {
				readyCallback.call(this);
			}
		} else {
			this.ymaps.then((ymaps) => {
				map =  new ymaps.Map("mapContainer", myOptions);
				self.model.set('map', map);

				readyCallback.call(self);
			});
			self.model.set('map', 'loading');
		}
	},
	initialize:function(options) {
		options.hotelMapView ? this.hotelMapView = options.hotelMapView : null;
		options.searchPageModel ? this.searchPageModel = options.searchPageModel : null;
		options.HotelsList ? this.HotelsList = options.HotelsList : null;

        this.currentHotel = options.currentHotel;
        this.$hotelInfoContainer = $('#hotelInfoContainer');

		this.ymaps = this.ymaps || ymapsLoader.load(appConfig.yamapsUrl);

		this.hotelSearchField = new MapHotelSearch({
			el:'.mapLayer .searchHotels',
			searchPageModel: this.searchPageModel,
			hotelsMapView:this
		});

		this.initMap(function() {
			this.initEvents();
			this.renderPoints();
		});

	}
});

export default HotelsMapView;
